module.exports = __webpack_public_path__ + "static/media/cheers-todd.6fc44ea4.png";